import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-skill',
  templateUrl: './create-skill.component.html',
  styleUrls: ['./create-skill.component.css']
})
export class CreateSkillComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
